import { RateUnit } from '@clawhire/shared';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export interface RateUnitToggleProps {
  value: RateUnit;
  onChange: (unit: RateUnit) => void;
  disabled?: boolean;
  label?: string;
  className?: string;
}

/** Segmented "per hour / per day" control (two options, so no dropdown). */
export function RateUnitToggle({
  value,
  onChange,
  disabled,
  label = 'Rate unit',
  className,
}: RateUnitToggleProps) {
  return (
    <div
      role="group"
      aria-label={label}
      className={cn('inline-flex h-9 items-center rounded-md border p-0.5', className)}
    >
      {RateUnit.codes.map((code) => (
        <Button
          key={code}
          type="button"
          variant={value === code ? 'secondary' : 'ghost'}
          size="sm"
          className="h-7"
          aria-pressed={value === code}
          disabled={disabled}
          onClick={() => onChange(code)}
        >
          {RateUnit.label(code)}
        </Button>
      ))}
    </div>
  );
}
